<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import ComponentLoader from '../globals/ComponentLoader'

const props = defineProps([
    'title',
    'classes',
    'route'
])

const loading = ref(true)
const content = ref(null)

onMounted( () => fetchBrandListing())

const fetchBrandListing = () => {
    axios.post(props.route)
    .then( response => {
        if ( response.status === 200 && response.data.length ) {
            content.value = response.data
            loading.value = false
        }  else flash('Niečo sa pokazilo.', 'danger')
    }).catch( error => flash(error.message, 'danger'))
}
</script>

<template>
      <section class="brand-listing" :class="classes">

       
            <div class="container">
                <slot name="heading"></slot>
                
                <template  v-if="content && content.length">
                    <transition name="fade" appear>
                        <div v-html="content"></div>
                    </transition>
                </template>
            </div>


        <template v-if="loading">
            <ComponentLoader />
        </template>

    </section>
</template>   